import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
//import { Guid } from 'guid-typescript';
import { AuditModel } from '../models/audit.model';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  from,
  Observable,
  of,
  Subject,
  Subscription,
} from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

const Cliente = 'WebOnboarding';
const UsuarioFonalIni = 'Desconocido';
const VarName = 'Audit';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private _audith: BehaviorSubject<AuditModel> = new BehaviorSubject(
    new AuditModel()
  );
  public readonly audith: Observable<AuditModel> = this._audith.asObservable();
  private auditDataSubject: Subject<AuditModel> = new Subject<AuditModel>();
  private readonly urlGetIp: string = 'get-ip-audit';
  url!: string;


  constructor(private router: Router, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    this.url = baseUrl + 'api/main/';
  }

  star(a = 'a'): Observable<AuditModel> {
    console.log('star');
    const tempAudit = new AuditModel();
    tempAudit.clear();
    return this.getIPAddress().pipe(
      take(1),
      mergeMap((next) => {
        console.log('next original', next);
      
        tempAudit.Cliente = Cliente;
        tempAudit.IdAcceso = next.ip;
        tempAudit.TipoAcceso = 0;
        //tempAudit.Token = String(Guid.create());
        tempAudit.Token = crypto.randomUUID();
        tempAudit.UsuarioFinal = UsuarioFonalIni;
        sessionStorage.setItem(VarName, btoa(JSON.stringify(tempAudit)));
        this.auditDataSubject.next(tempAudit);

        return of(tempAudit);
      })
    );
  }

  getAuditDataObservable(): Observable<AuditModel> {
    return this.auditDataSubject.asObservable();
  }

  getUsuarioFonalIni() {
    return UsuarioFonalIni;
  }

  getCliente() {
    return Cliente;
  }
  getAudit() {
    
    const guardado = sessionStorage.getItem(VarName);
    if (guardado) {
      console.log("guardado", guardado);
      return JSON.parse(atob(guardado));
    } else {
      console.log("no guardado");
      this.router.navigate(['/']);
    }
  }

  setFinalUser(user: string) {
    const tempAudit = this.getAudit();
    tempAudit.UsuarioFinal = user;
    sessionStorage.setItem(VarName, btoa(JSON.stringify(tempAudit)));
  }

  getVarName() {
    return VarName;
  }

  getIPAddress() {
    //return this.http.get<any>('https://api.ipify.org/?format=json');

    return this.http.get<any>(this.url + this.urlGetIp);

  }
}
